var _rect, _rect2, _g, _rect3, _rect4, _circle, _circle2, _g2, _rect5, _path, _g3, _rect6, _rect7, _circle3, _circle4, _g4, _rect8, _rect9, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHow1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 595,
    height: 300,
    viewBox: "0 0 595 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 155,
    width: 400,
    height: 300,
    rx: 24,
    fill: "#081131"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 162,
    width: 400,
    height: 96,
    rx: 12,
    fill: "#162044"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("rect", {
    x: 471,
    y: 186,
    width: 100,
    height: 48,
    rx: 8,
    fill: "#4E5A85"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 497,
    y: 204,
    width: 48,
    height: 12,
    rx: 6,
    fill: "#7E8BB6"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 291,
    y: 194,
    width: 134,
    height: 12,
    rx: 6,
    fill: "#4E5A85"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 291,
    y: 214,
    width: 99,
    height: 12,
    rx: 6,
    fill: "#4E5A85"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 243,
    cy: 210,
    r: 32,
    fill: "#FBAF52"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_798_11612",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 211,
    y: 178,
    width: 64,
    height: 64
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 243,
    cy: 210,
    r: 32,
    fill: "#FEECD0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_798_11612)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 178,
    width: 64,
    height: 64,
    fill: "url(#pattern0)"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 521,
    y: 56,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#5454D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M552.999 101.333C545.635 101.333 539.666 95.3641 539.666 88.0001C539.666 80.6361 545.635 74.6667 552.999 74.6667C560.363 74.6667 566.333 80.6361 566.333 88.0001C566.333 95.3641 560.363 101.333 552.999 101.333ZM554.333 88.0001V81.3334H551.666V90.6667H559.666V88.0001H554.333Z",
    fill: "#CCD2E9"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_798_11612)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 42,
    width: 400,
    height: 96,
    rx: 12,
    fill: "#162044"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 321,
    y: 66,
    width: 100,
    height: 48,
    rx: 8,
    fill: "#5454D4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 84,
    width: 48,
    height: 12,
    rx: 6,
    fill: "#7A7AD5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 90,
    r: 32,
    fill: "#2DB27C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_798_11612",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 58,
    width: 64,
    height: 64
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 90,
    r: 32,
    fill: "#FEECD0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_798_11612)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 56,
    width: 64,
    height: 66,
    fill: "url(#pattern1)"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 141,
    y: 74,
    width: 140,
    height: 12,
    rx: 6,
    fill: "#4E5A85"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 141,
    y: 94,
    width: 104,
    height: 12,
    rx: 6,
    fill: "#4E5A85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M285.125 145.5C284.75 145 284.375 144.125 283.625 143C283.25 142.375 282.125 141.125 281.75 140.625C281.5 140.125 281.5 139.875 281.625 139.375C281.75 138.625 282.5 138 283.375 138C284 138 284.625 138.5 285.125 138.875C285.375 139.125 285.75 139.625 286 139.875C286.25 140.125 286.25 140.25 286.5 140.5C286.75 140.875 286.875 141.125 286.75 140.625C286.625 140 286.5 139 286.25 138C286.125 137.25 286 137.125 285.875 136.625C285.75 136 285.625 135.625 285.5 135C285.375 134.625 285.25 133.625 285.125 133.125C285 132.5 285 131.375 285.5 130.875C285.875 130.5 286.625 130.375 287.125 130.625C287.75 131 288.125 131.875 288.25 132.25C288.5 132.875 288.75 133.75 288.875 134.75C289.125 136 289.5 137.875 289.5 138.25C289.5 137.75 289.375 136.875 289.5 136.375C289.625 136 289.875 135.5 290.375 135.375C290.75 135.25 291.125 135.25 291.5 135.25C291.875 135.375 292.25 135.625 292.5 135.875C293 136.625 293 138.25 293 138.125C293.125 137.625 293.125 136.625 293.375 136.125C293.5 135.875 294 135.625 294.25 135.5C294.625 135.375 295.125 135.375 295.5 135.5C295.75 135.5 296.25 135.875 296.375 136.125C296.625 136.5 296.75 137.75 296.875 138.25C296.875 138.375 297 137.75 297.25 137.375C297.75 136.625 299.5 136.375 299.625 138.125C299.625 139 299.625 138.875 299.625 139.5C299.625 140.125 299.625 140.5 299.625 141C299.625 141.5 299.5 142.625 299.375 143.125C299.25 143.5 298.875 144.375 298.5 144.875C298.5 144.875 297.125 146.375 297 147.125C296.875 147.875 296.875 147.875 296.875 148.375C296.875 148.875 297 149.5 297 149.5C297 149.5 296 149.625 295.5 149.5C295 149.375 294.375 148.5 294.25 148.125C294 147.75 293.625 147.75 293.375 148.125C293.125 148.625 292.5 149.5 292 149.5C291.125 149.625 289.375 149.5 288.125 149.5C288.125 149.5 288.375 148.25 287.875 147.75C287.5 147.375 286.875 146.75 286.5 146.375L285.125 145.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M285.125 145.5C284.75 145 284.375 144.125 283.625 143C283.25 142.375 282.125 141.125 281.75 140.625C281.5 140.125 281.5 139.875 281.625 139.375C281.75 138.625 282.5 138 283.375 138C284 138 284.625 138.5 285.125 138.875C285.375 139.125 285.75 139.625 286 139.875C286.25 140.125 286.25 140.25 286.5 140.5C286.75 140.875 286.875 141.125 286.75 140.625C286.625 140 286.5 139 286.25 138C286.125 137.25 286 137.125 285.875 136.625C285.75 136 285.625 135.625 285.5 135C285.375 134.625 285.25 133.625 285.125 133.125C285 132.5 285 131.375 285.5 130.875C285.875 130.5 286.625 130.375 287.125 130.625C287.75 131 288.125 131.875 288.25 132.25C288.5 132.875 288.75 133.75 288.875 134.75C289.125 136 289.5 137.875 289.5 138.25C289.5 137.75 289.375 136.875 289.5 136.375C289.625 136 289.875 135.5 290.375 135.375C290.75 135.25 291.125 135.25 291.5 135.25C291.875 135.375 292.25 135.625 292.5 135.875C293 136.625 293 138.25 293 138.125C293.125 137.625 293.125 136.625 293.375 136.125C293.5 135.875 294 135.625 294.25 135.5C294.625 135.375 295.125 135.375 295.5 135.5C295.75 135.5 296.25 135.875 296.375 136.125C296.625 136.5 296.75 137.75 296.875 138.25C296.875 138.375 297 137.75 297.25 137.375C297.75 136.625 299.5 136.375 299.625 138.125C299.625 139 299.625 138.875 299.625 139.5C299.625 140.125 299.625 140.5 299.625 141C299.625 141.5 299.5 142.625 299.375 143.125C299.25 143.5 298.875 144.375 298.5 144.875C298.5 144.875 297.125 146.375 297 147.125C296.875 147.875 296.875 147.875 296.875 148.375C296.875 148.875 297 149.5 297 149.5C297 149.5 296 149.625 295.5 149.5C295 149.375 294.375 148.5 294.25 148.125C294 147.75 293.625 147.75 293.375 148.125C293.125 148.625 292.5 149.5 292 149.5C291.125 149.625 289.375 149.5 288.125 149.5C288.125 149.5 288.375 148.25 287.875 147.75C287.5 147.375 286.875 146.75 286.5 146.375L285.125 145.5Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M295.5 145.875V141.625",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M293 145.875L292.875 141.625",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M290.5 141.625V145.875",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_798_11612",
    transform: "scale(0.0625)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_798_11612",
    x: 0,
    y: 32,
    width: 490,
    height: 186,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 35
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.027451 0 0 0 0 0.054902 0 0 0 0 0.152941 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_798_11612"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_798_11612",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_798_11612",
    transform: "translate(-0.015625) scale(0.0644531 0.0625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_798_11612",
    width: 16,
    height: 16,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD7SURBVHgBpVK/CwFhGH5OSvkxSbrbpJQy2mRSYmBglWQxGfwFMpiUGy6DRZLBTBZlkGxWKYuJS1kx4nN13d1336m7Z/m+5/3e5+l93+/l3hfxDQdwwSHcWpIsTpmJPM9jMcyAWYGVmECWZRQaa7aBXbjNgpt9l624HsGsQCv0czldopFTBvt5BXbAGffgIcQtBT6rFghCiRyqu7rKpVuMKaYMvNkW8kMBm/5VNWmGT7+T8PK5RxlQv0DEtXYa484WVdR1b5FA1LoCLYjJJDWi4sYZUUMkbbwOQLBEm94l8X8Fz5WoE5iJtDDdxJlHAJbfi6TwwVJQLhKd+wG5kkc0F5mVXAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_798_11612",
    width: 16,
    height: 16,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEOSURBVHgBpZO/q0FhGMe/53a7w+0Od7ndbrfMyMhg8hcoZVFiUopiUCKDDCJlYDhSSillYVEGpVgYjt2uDFJWk/Dmx3mP53WU861T7/d53ufzft9Or7RtKwcY0BsMyjDg/b5g3dhh/qMbLb9AfjWHboJHw0yLNZD5tz9PcNW4Uqa101e7rLdRFwXER5K6eQoU3Gov3T/7sE/Bwyu8Ig2Ap/Oni7wQwKQMnAgt5ZtPxWThAUJAKBhD3RZAeTG8QYrVyLl38vsSBZC/wIazXj9y3TYSkDW9L+sPdnoJeDFIwxQh9XrHofHS/WNi1+jtZ0h9eMhwspkhNZKg0apqBkRDugAm53cek081KlvzntcRBZxKjWHYo3oAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHow1);
export default __webpack_public_path__ + "static/media/how1.ae67ead1755386f6c3ffe143d0f13438.svg";
export { ForwardRef as ReactComponent };